import {useTourTracking} from '../../analytics/TourTracking';
import s from './TourPlans.module.scss';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faBus,
    faCalendarAlt,
    faClock,
    faCoffee,
    faComments,
    faSun,
    faUtensils
} from '@fortawesome/free-solid-svg-icons';
import {FaCheckCircle} from 'react-icons/fa';
import Button from '../../components/Button/Button';
import {Modal} from 'bootstrap';
import TourSchedule from "./TourSchedule";
import {useEffect, useState} from 'react';
import Loading from "../../components/Loading/Loading";
import LoadingInside from "../../components/Loading/LoadingInside";

const iconMap = {
    sun: faSun,
    clock: faClock,
    calendar: faCalendarAlt,
    bus: faBus,
    utensils: faUtensils,
    comments: faComments,
    coffee: faCoffee,
};

const TourPlans = ({plans}) => {
    const track = useTourTracking();

    useEffect(() => {
        if (plans?.length === 1) {

            const planId = plans[0].id;
            fetchSchedules(planId);
        }
    }, [plans]);

    const apiUrl = process.env.REACT_APP_API_URL;
    const [selectedPlanId, setSelectedPlanId] = useState(null);
    const [schedules, setSchedules] = useState([]);
    const [scheduleLoading, setScheduleLoading] = useState(false);

    const fetchSchedules = async (planId) => {
        try {
            setScheduleLoading(true);

            // OPEN modal immediately
            if (plans?.length !== 1) {
                const modalEl = document.getElementById('scheduleModal');
                const modal = new Modal(modalEl);

                modal.show();
            }
            const response = await fetch(`${apiUrl}/api/schedule/${planId}`);

            const data = await response.json();

            setSchedules(data);
            setSelectedPlanId(planId);

        } catch (error) {
            console.error('Error fetching schedules:', error);
        } finally {
            setScheduleLoading(false);
        }
    };

    // const closeModal = () => {
    //   setIsModalOpen(false);
    //   setSchedules([]);
    // };

    // 🔥 SINGLE PLAN UI
    if (plans?.length === 1) {
        const plan = plans[0];

        return (
            <div className={s.root}>
            <div key={plan.id} className={s.planCard}>
                <div className={s.titleRow}>
                    {plan.link ? (
                        <a
                            href={`/tours/${plan.link}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={s.link}
                        >
                            <h4>{plan.campaign}</h4>
                        </a>
                    ) : (
                        <h4>{plan.campaign}</h4>
                    )}

                </div>
                {plan.note && <span className={s.note}>{plan.note}</span>}
                <div className={s.planInfo}>
                    <div>
                        <FontAwesomeIcon icon={iconMap.clock}/> {plan.duration}
                    </div>
                    <div>
                        <FontAwesomeIcon icon={iconMap.calendar}/> {plan.availability}
                    </div>
                    <div>
                        <FontAwesomeIcon icon={iconMap.bus}/> {plan.transfer ? '送迎あり' : '送迎なし'}
                    </div>
                    {/* <div>
                <FontAwesomeIcon icon={iconMap.utensils} /> 昼食
              </div> */}
                    {plan.japanese_guide == true && (
                        <div>
                            <FontAwesomeIcon icon={iconMap.comments}/> 日本語ガイド
                        </div>
                    )}
                </div>
                {plan.description &&
                    <div className={s.description}>
                        {plan.description.split('\n').map((line, index) => (
                            <p key={index}>{line}</p>
                        ))}
                    </div>
                }
                <div className={s.includes}>
                    <span>含まれるもの</span>
                    <ul className={s.includesList}>
                        {plan.includes?.map((item, index) => (
                            <li key={index} className={s.includeItem}>
                                <FaCheckCircle className={s.icon}/>
                                <span className={s.text}>{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                {/* {plan.ad_price && (
            <div className={s.priceTable}>
            <ul>
              <li>大人: <span>${plan.ad_price}</span></li>
              <li>子供: <span>${plan.ch_price}</span></li>
              <li>幼児: <span>$0</span></li>
              <li>家族: <span>${plan.family_price}</span></li>
            </ul>
          </div>
          )} */}
            </div>
                {scheduleLoading ? (
                    <LoadingInside/>
                ) : (
                    <TourSchedule scheduleData={schedules} />
                )}
            </div>
        );
    }

    return (
        <div className={s.root}>
            {plans.map((plan) => (
                <div key={plan.id} className={s.planCard}>
                    <div className={s.titleRow}>
                        {plan.link ? (
                            <a
                                href={`/tours/${plan.link}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={s.link}
                            >
                                <h4>{plan.campaign}</h4>
                            </a>
                        ) : (
                            <h4>{plan.campaign}</h4>
                        )}
                        <Button
                            label="スケジュールを見る"
                            onClick={() => { track('schedule_open', {plan_id: String(plan.id), plan_name: plan.campaign}); fetchSchedules(plan.id); }}
                            className={s.scheduleButton}
                        />
                    </div>
                    {plan.note && <span className={s.note}>{plan.note}</span>}
                    <div className={s.planInfo}>
                        <div>
                            <FontAwesomeIcon icon={iconMap.clock}/> {plan.duration}
                        </div>
                        <div>
                            <FontAwesomeIcon icon={iconMap.calendar}/> {plan.availability}
                        </div>
                        <div>
                            <FontAwesomeIcon icon={iconMap.bus}/> {plan.transfer ? '送迎あり' : '送迎なし'}
                        </div>
                        {/* <div>
                <FontAwesomeIcon icon={iconMap.utensils} /> 昼食
              </div> */}
                        {plan.japanese_guide == true && (
                            <div>
                                <FontAwesomeIcon icon={iconMap.comments}/> 日本語ガイド
                            </div>
                        )}
                    </div>
                    {plan.description &&
                        <div className={s.description}>
                            {plan.description.split('\n').map((line, index) => (
                                <p key={index}>{line}</p>
                            ))}
                        </div>
                    }
                    <div className={s.includes}>
                        <span>含まれるもの</span>
                        <ul className={s.includesList}>
                            {plan.includes?.map((item, index) => (
                                <li key={index} className={s.includeItem}>
                                    <FaCheckCircle className={s.icon}/>
                                    <span className={s.text}>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {/* {plan.ad_price && (
            <div className={s.priceTable}>
            <ul>
              <li>大人: <span>${plan.ad_price}</span></li>
              <li>子供: <span>${plan.ch_price}</span></li>
              <li>幼児: <span>$0</span></li>
              <li>家族: <span>${plan.family_price}</span></li>
            </ul>
          </div>
          )} */}
                </div>
            ))}

            <div
                className="modal fade"
                id="scheduleModal"
                tabIndex="-1"
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title">スケジュール</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                            ></button>
                        </div>

                        <div className="modal-body">

                            {scheduleLoading ? (
                                <LoadingInside height={"70vh"}/>
                            ) : (
                                <TourSchedule scheduleData={schedules} />
                            )}

                        </div>

                    </div>
                </div>
            </div>
        </div>


    );
};

export default TourPlans;
